import * as tslib_1 from "tslib";
import { DefaultGraphicsFactory } from "@awayjs/graphics";
import { Billboard, TextField, MovieClip, Sprite, DisplayObjectContainer } from "@awayjs/scene";
import { MethodMaterial } from "@awayjs/materials";
var DefaultSceneGraphFactory = (function (_super) {
    tslib_1.__extends(DefaultSceneGraphFactory, _super);
    function DefaultSceneGraphFactory() {
        return _super.apply(this, arguments) || this;
    }
    DefaultSceneGraphFactory.prototype.createMovieClip = function (timeline) {
        if (timeline === void 0) { timeline = null; }
        return new MovieClip(timeline);
    };
    DefaultSceneGraphFactory.prototype.createSprite = function (prefab) {
        if (prefab === void 0) { prefab = null; }
        if (prefab)
            return prefab.getNewObject();
        return new Sprite();
    };
    DefaultSceneGraphFactory.prototype.createDisplayObjectContainer = function () {
        return new DisplayObjectContainer();
    };
    DefaultSceneGraphFactory.prototype.createTextField = function () {
        return new TextField();
    };
    DefaultSceneGraphFactory.prototype.createBillboard = function (material) {
        return new Billboard(material);
    };
    DefaultSceneGraphFactory.prototype.createMaterial = function (imageColor, alpha) {
        return new MethodMaterial(imageColor, alpha);
    };
    return DefaultSceneGraphFactory;
}(DefaultGraphicsFactory));
export { DefaultSceneGraphFactory };



// WEBPACK FOOTER //
// ../dist/lib/factories/DefaultSceneGraphFactory.js